<template>
    <div class="createReservationTopArea">
        <div class="row mt-0">
            <div class="col-sm-9 font-weight-600 fs-largest">
                <span>{{this.reservation.product.name}}</span>
            </div>
            <div class="col-sm-3 font-weight-600 fs-largest text-right">
                <span v-if="this.reservation.sequencialNumber">#{{this.reservation.sequencialNumber}}</span>
            </div>
        </div>
        <div class="row mt-0">
            <div class="col-sm-3">
                <div class="bold dark fs-small">Location:</div>
                <div class="bold py-1">{{ location }}</div>
            </div>
            <div class="col-sm-3">
                <div class="bold dark fs-small">Departure:</div>
                <div class="bold py-1">{{ departure }}</div>
            </div>
            <div class="col-sm-3">
                <div class="bold dark fs-small">Duration:</div>
                <div class="bold py-1">{{ hourToDuration(this.reservation.event.duration) }}</div>
            </div>
            <div class="col-sm-3 resourceSelectorNewReservation">
                <div class="bold dark fs-small">Resource:</div>
                <v-select :options="resourcesWithAvailability" label="name" v-model="reservation.selectedResource"></v-select>
            </div>
        </div>
    </div>
</template>

<script>
import extendedVSelect from '@/extends/vue-select'
import { reservationsMixin } from '@/mixins/reservations'
export default {
    mixins: [reservationsMixin],
    data: function() {
        return {

        }
    },
    props: {
        reservation: {
            type: Object
        },
    },
    computed: {
        location: function() {
            return this.reservation.event.location;
        },
        resourceAndLocation: function() {
            let resourcesNames = [];

            for (let resource of this.reservation.event.eventResources) {
                resourcesNames.push(resource.name);
            }

            let resourcesString = resourcesNames.join(', ');

            // return resourcesString + ' - ' +  (this.reservation.product.location != null)? this.reservation.product.location : '' ;
            let location = null;
            if(this.reservation.event.location){
                location = this.reservation.event.location;
            }
            return resourcesString + ((resourcesString != '' && location != null)? ' - ' : '') + ((location != null)? location : '')
        },
        departure: function() {
            return  moment(this.reservation.event.start).format('DD/MM/YYYY - hh:mmA')
        }
    },
    components: {
        vSelect: extendedVSelect
    }
}
</script>

<style lang="scss" scoped>
</style>

<style lang="scss">
.createReservationTopArea{
    .dropdown{
        .dropdown-toggle{
            height: 29px;

            .selected-tag{
                height: 29px;
                margin: 0;
                line-height: 25px;
            }

            .open-indicator{
                height: 17px;
            }
        }

    }
}

.resourceSelectorNewReservation .v-select .dropdown-toggle .vs__actions{
    top: 3px !important;
}
</style>



// WEBPACK FOOTER //
// TopArea.vue?5bb75bbe